export default "__VITE_ASSET__ClsJGErz__"